export default "__VITE_ASSET__Bi57m9l2__"